import { BookingDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/booking_events_pb';
import { BookingStatus } from '@rematter/frontend-lib-api-client/grpc/trade/booking_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  humanReadableDateTime,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { bookingStatusLabels } from '../enumLabels';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

const getStatusColor = (status: BookingStatus): ThemeColor => {
  switch (status) {
    case BookingStatus.DRAFT:
      return 'neutral';
    case BookingStatus.OPEN:
      return 'primary';
    case BookingStatus.SHIPPED:
      return 'teal';
    case BookingStatus.COMPLETED:
      return 'success';
    case BookingStatus.VOIDED:
      return 'failure';
    default:
      return 'neutral';
  }
};

type BookingDeletedDetailProps = {
  event: BookingDeletedEvent;
};

export const BookingDeletedDetail = ({ event }: BookingDeletedDetailProps) => {
  const booking = event.booking;

  if (!booking) {
    return (
      <Col className="@BookingDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const cutOffDateStr = protoTimestampToZonedDateTimeString(booking.cutOffDate);

  return (
    <Col className="@BookingDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Booking
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={booking.id} />
          <FieldDisplay label="Booking Number" value={booking.documentNumber} />
          <BadgeField
            label="Status"
            value={bookingStatusLabels[booking.status]}
            color={getStatusColor(booking.status)}
          />
          <IDField label="Purchase Order ID" value={booking.purchaseOrderId} />
          <IDField label="Carrier ID" value={booking.carrierId} />
          <FieldDisplay label="Vessel Name" value={booking.vesselName} />
          {cutOffDateStr && (
            <FieldDisplay
              label="Cut Off Date"
              value={humanReadableDateTime(cutOffDateStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
